import { ViewModel,View, ObservableArray } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { getAsBoolean } from "src/uicomponents/components/utilities";
import { BooleanType, ClassType, FloatType, IntegerType, IPropertyTypeVisitor, KnownClassType, ListType, PropertyType, StringType } from "../../structure";
import { DataModelClass, GetAllPropertyTypesMessage, IMemberContainer, Property } from "../dataModelBuilder-viewModel";
import { TypeSelectorViewModel } from "../typeSelector/typeSelector-viewModel";
import { DefaultValueManipulatorFactory, IDefaultValueManipulator } from "./defaultValueManipulation/defaultValueManipulator";
import { NullViewModel } from "./defaultValueManipulation/null/null-viewModel";
import  { PropertyManipulationView } from "./propertyManipulation-view"

export class PropertyManipulationViewModel extends ViewModel implements IPopup{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.typeSelector = new TypeSelectorViewModel(this);
        this.typeSelector.onSelectedTypeChanged = x=>{
            this.updateDefaultValueInitializer();
        }
    }
    closePopup(result?: any) {
    }
    GetDefaultView(): View <ViewModel> {
        return new PropertyManipulationView();
    }
    public getTypeId(): string {
        return "VM-00368CC1-6E33-4630-9CEA-224E0B24E5DF"
    }

    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set cls(v: IMemberContainer) { this._cls = v; } public get cls(): IMemberContainer { return this._cls;} private _cls: IMemberContainer;
    public set typeSelector(v: TypeSelectorViewModel) { this._typeSelector = v; } public get typeSelector(): TypeSelectorViewModel { return this._typeSelector;} private _typeSelector: TypeSelectorViewModel;
    public set shallInitialize(v: boolean) { 
        this._shallInitialize =getAsBoolean(v); 
        this.updateDefaultValueInitializer();
    } public get shallInitialize(): boolean { return this._shallInitialize;} private _shallInitialize: boolean;
    public set defaultValueSelector(v: IDefaultValueManipulator) { this._defaultValueSelector = v; } public get defaultValueSelector(): IDefaultValueManipulator { return this._defaultValueSelector;} private _defaultValueSelector: IDefaultValueManipulator;
    
    confirm(){
        let property = new Property(<any>this.cls);
        property.name = this.name;
        property.type = this.typeSelector.getSelectedType();
        property.shallInitialize = this.shallInitialize;
        property.defaultValue = this.defaultValueSelector.getDefaultValue();
        this.closePopup(property);
    }

    
    editProperty(p: Property) {
        this.name = p.name;
        this.typeSelector.setPropertyType(p.type);
        this.shallInitialize = p.shallInitialize;
        this.defaultValueSelector.setDefaultValue(p.defaultValue);
    }
    

    back(){
        this.closePopup();
    }
    
    
    private updateDefaultValueInitializer(){
        if(this.shallInitialize && this.typeSelector.selectedType){
            this.defaultValueSelector = new DefaultValueManipulatorFactory().create(this.typeSelector.getSelectedType(),this);
        }else{
            this.defaultValueSelector = new NullViewModel(this);
        } 
    }
}
